/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPDOCUMENTTYPE = {
    ActingOnBehalfOfFormAeb2131: 'ACTINGONBEHALFOF',
    AdvanceGuarantee: 'ADVANCEGUARANTEE',
    AmericanCitizenFormW9: 'AMERICANCITIZEN',
    ApplicationForm: 'APPLICATIONFORM',
    AuthorisedSignatories: 'AUTHORISEDSIGNATORY',
    BirthCertificate: 'BIRTHCERTIFICATE',
    CgtStatements: 'CAPITALGAINSTAX',
    ConfirmationOfChangesaeb2061: 'CONFIRMCHANGES',
    CourtOrder: 'COURTORDER',
    DebitOrderInstruction: 'DEBITORDER',
    DebitOrderAuthorisation: 'DEBITORDERAUTH',
    DividendTaxDeclarationDtd: 'DIVIDENDTAXDECL',
    ThirdPartyDetails: 'DUEDILIGENCE',
    SelfCertificationForms: 'FATCA',
    FiaDocuments: 'FIAIDFORM',
    LetterOfAuthority: 'FICA LETTER',
    Resolution: 'FICA RESOLUTION',
    TrustDeed: 'FICA TRUST DEED',
    FicaLegalEntityDocumentation: 'FICALEGALENTITY',
    FinancialContributorFormAeb2131: 'FINANCIALCONTRIBUTOR',
    FinancialNeedsAnalysis: 'FINANCNEEDSANALYS',
    FormH: 'FORMH',
    FormJ: 'FORMJ',
    AuthorisedFspMandate: 'FSP MANDATE',
    GuaranteedOptionQuote: 'GUARANTEEDQUOTE',
    IdentificationDocumentBeneficiary: 'IDBENEFICIARY',
    IdentificationDocument: 'IDENTITYDOCUMENT',
    IdentificationDocumentNominee: 'IDNOMINEE',
    IdentificationDocumentSecondLife: 'IDSECONDLIFE',
    InvestmentMandate: 'INVESTMENTMANDATE',
    Irp3TaxDirective: 'IRP3',
    TransferCertificateit3s: 'IT3TRANSFER',
    OtherDocuments: 'OTHER',
    PassportDocument: 'PASSPORTDOCUMENT',
    CedingFormAe2170: 'POLICYCEDINGFORM',
    PowerOfAttorney: 'POWEROFATTORNEY',
    ProofOfBankAccount: 'PROOFOFBANKACCOUNT',
    ProofOfPayment: 'PROOFOFPAYMENT',
    PortfolioManagerDealSheet: 'PRTFOLMANGRDEALSHEET',
    QuotationDocument: 'QUOTE',
    RecognitionOfTransfer: 'RECOGNITIONOFTRANSFR',
    RecordOfAdvice: 'RECORDOFADVICE',
    ReplacementPolicyFormC016: 'REPLACEMENTPOLICY',
    ReplacementPolicyAdviceRecord: 'REPLACEPOLICYADVICE',
    ReQuote: 'REQUOTE',
    RetirementOptionLetter: 'RETIREMENTOPTION',
    RiskToleranceAnalysisForm: 'RISKTOLERANCEANALYS',
    Section14Documentation: 'SEC14',
    Section37Documentation: 'SEC37',
    ShareMandate: 'SHARE MANDATE',
    SpecimenSignature: 'SPECIMANSIGNATURE',
    StatementOfUnitsTransferred: 'UNITTRANSFERSTATEMNT',
    UtilityBillOrProofOfResidence: 'UTILITY_PROOFOFRES',
    WithholdingTaxOnInterestDeclarationWtid: 'WITHOLDINGTAXDECL',
    WrapMandate: 'WRAP MANDATE',
    GepfTransferFormZ1525: 'Z1525',
    ThirdPartyDeclaration: 'THIRDPARTYDECL',
    FicaAddendum: 'FICAADDENDUM',
    IndemnityFormForThirdPartyPayments: 'INDEMNITYFORM',
    RelatedPartyDetailsForm: 'RELATEDPARTYFORM'
} as const;
export type IAPDOCUMENTTYPE = typeof IAPDOCUMENTTYPE[keyof typeof IAPDOCUMENTTYPE];


export function IAPDOCUMENTTYPEFromJSON(json: any): IAPDOCUMENTTYPE {
    return IAPDOCUMENTTYPEFromJSONTyped(json, false);
}

export function IAPDOCUMENTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPDOCUMENTTYPE {
    return json as IAPDOCUMENTTYPE;
}

export function IAPDOCUMENTTYPEToJSON(value?: IAPDOCUMENTTYPE | null): any {
    return value as any;
}

